import { Navigate, Outlet } from 'react-router-dom';
const EnterpriseAuth = ()=>{
    const role = JSON.parse(localStorage.getItem('user_role'))
    return role === 4 ? <Outlet/>:<Navigate to='/'/>
}
export default EnterpriseAuth;